export default {
  unlocked_plural: '{{count}} aanbiedingen zijn ontgrendeld',
  unlocked: '{{offer}} aanbieding is ontgrendeld',
  removed_one: '{{offer}} aanbieding is verwijderd',
  removed_other: '{{count}} zijn verwijderd',
};
